import { post } from "../api";

export const doInscription = async (compte: {nom: string; prenom: string; telephone: string; email: string; adresse: string}) => {

    const response = await post("/auth/inscription", compte);
    return response.data;
}
